<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="fetch">
          搜索
        </el-button>
        <el-button
          v-hp="'export'"
          style="margin-right: 10px"
          @click="exportList"
        >
          导出
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          v-hp="'recharge'"
          style="margin-right: 10px"
          type="primary"
          @click="showAddTaxM(null)"
        >
          充值
        </el-button>
      </div>
    </customize-page>

    <el-dialog title="凭证" :visible.sync="isShowVoucher">
      <el-image style="height: 400px" :src="voucherUrl" fit="contain">
        <div slot="placeholder" class="image-slot">
          加载中<span class="dot">...</span>
        </div>
      </el-image>
    </el-dialog>

    <el-dialog title="税金充值" width="450px" :visible.sync="showAddTax">
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="addTaxForm"
        label-width="80px"
      >
        <el-form-item label="电商企业">
          <el-select
            v-model="addTaxForm.enterpriseNid"
            placeholder="请选择电商企业"
          >
            <el-option
              v-for="(item, index) in getEECommerce"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货主id">
          <el-input
            v-model="addTaxForm.accountNid"
            placeholder="为空时则只给主账户充值"
          ></el-input>
        </el-form-item>
        <el-form-item label="充值口岸">
          <el-select v-model="addTaxForm.portNid" placeholder="请选择口岸">
            <el-option
              v-for="(item, index) in portList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值类型">
          <el-select
            v-model="addTaxForm.rechargeTypeStr"
            placeholder="请选择充值类型"
          >
            <el-option label="罚款缴纳" value="TAX_PENALTY"></el-option>
            <el-option label="税金充值" value="TAX_PREPAY"></el-option>
            <el-option label="税金补缴" value="BACK_TAX"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值金额">
          <el-input v-model="addTaxForm.rechargeAmount"></el-input>
        </el-form-item>
        <el-form-item label="上传凭证">
          <el-upload
            :name="uploadName"
            :data="{ _aid: 401 }"
            :limit="1"
            :on-preview="handlePreview"
            :on-progress="fileProgress"
            :on-change="fileChange"
            :on-exceed="handleExceed"
            :before-upload="fileBeforeUpload"
            :on-success="fileUploadSuccessHandle"
            :file-list="addTaxForm.fileList"
            action="/file.api"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <!--                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
          </el-upload>
        </el-form-item>
        <el-form-item label="充值日期">
          <el-date-picker
            type="datetime"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="addTaxForm.rechargeTimeStr"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveTax('WAIT_AUDIT')"
            >提交审核</el-button
          >
          <el-button
            v-if="addTaxForm.id == null"
            type="primary"
            @click="saveTax('DRAUGHT')"
            >保存草稿</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      style="text-align: center; font-size: 18px"
      title="税金审核"
      width="400px"
      :visible.sync="isShowAudit"
    >
      <el-row>
        <el-col :span="12">电商企业</el-col>
        <el-col :span="12">{{ currentAudit.enterpriseName }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">充值口岸</el-col>
        <el-col :span="12">{{ currentAudit.portName }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">充值类型</el-col>
        <el-col :span="12">{{ currentAudit.rechargeTypeStr }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">充值金额</el-col>
        <el-col :span="12">{{ currentAudit.rechargeAmount }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">凭证信息</el-col>
        <el-col :span="12">
          <el-link
            type="info"
            v-on:click="showVoucher(currentAudit.evidenceUrl)"
          >
            查看凭证
          </el-link>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">充值日期</el-col>
        <el-col :span="12">{{ currentAudit.rechargeTimeStr }}</el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-input
            type="textarea"
            v-model="auditDataForm.remarks"
            placeholder="(选填)审核驳回时必填！"
          >
          </el-input>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-col :span="12">
          <el-button
            v-on:click="auditTax(currentAudit.id, 'AUDIT_PASS')"
            type="primary"
          >
            审核通过
          </el-button>
        </el-col>
        <el-col :span="12">
          <el-button
            v-on:click="auditTax(currentAudit.id, 'AUDIT_REJECT')"
            type="warning"
          >
            审核驳回
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
      style="text-align: center; font-size: 18px"
      width="40%"
      title="税金操作记录"
      :visible.sync="isShowListOprator"
    >
      <el-table style="width: 100%" :data="taxOpratorLogData">
        <el-table-column
          property="oprator"
          label="操作人"
          width="120"
        ></el-table-column>
        <el-table-column
          property="opratorInfo"
          label="操作信息"
          min-width="180"
        ></el-table-column>
        <el-table-column
          property="remarks"
          label="备注"
          width="120"
        ></el-table-column>
        <el-table-column
          property="gmtCreate"
          label="时间"
          width="120"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from "@/utils/common";
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapGetters, mapState } from "vuex";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import { getUserInfo } from "@/utils/user";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      uploadName: "CPRODUCT_IMG.taxVoucherPng",
      auditDataForm: {
        remarks: "",
      },
      defaultAddTaxForm: "",
      addTaxForm: {
        fileList: [],
        enterpriseNid: "",
        portNid: "",
        accountNid: "",
        rechargeTypeStr: "",
        rechargeAmount: "",
        rechargeTimeStr: "",
        evidenceUrl: "",
        uploadSuccess: false,
        id: null,
      },
      isShowListOprator: false,
      taxOpratorLogData: [],
      isShowAudit: false,
      currentAudit: {},
      showAddTax: false,
      isShowVoucher: false,
      voucherUrl: "",
      loading: false,
      dataList: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "充值编号",
          key: "id",
          width: 150,
          align: "center",
        },
        {
          title: "货主id",
          key: "accountNid",
          align: "center",
          width: 150,
        },
        {
          title: "电商企业编码",
          key: "enterpriseNid",
          align: "center",
          width: 150,
        },
        {
          title: "电商企业",
          width: 150,
          key: "enterpriseName",
          align: "center",
        },
        {
          title: "充值类型",
          width: 150,
          key: "rechargeTypeStr",
          align: "center",
        },
        {
          title: "充值金额",
          width: 200,
          key: "rechargeAmount",
          align: "center",
          render: (h, param) => {
            let rechargeAmount = param.row.rechargeAmount;
            if (rechargeAmount == null) {
              return <div>0.00</div>;
            }
            return <div>{(parseInt(rechargeAmount) / 100).toFixed(2)}</div>;
          },
        },
        {
          title: "充值时间",
          width: 180,
          key: "rechargeTimeStr",
          align: "center",
        },
        {
          title: "审核状态",
          width: 150,
          key: "auditStatusStr",
          align: "center",
        },
        {
          title: "生效时间",
          width: 200,
          key: "effectiveTimeStr",
          align: "center",
        },
        {
          title: "操作人",
          width: 100,
          key: "oprator",
          align: "center",
        },
        {
          title: "备注",
          "min-width": 200,
          key: "remarks",
          align: "center",
        },
        /*                    {
                                            title: "口岸编码",
                                            width: 200,
                                            key: "portNid",
                                            align: "center"
                                        },*/
        {
          title: "口岸",
          width: 200,
          key: "portName",
          align: "center",
        },
        {
          title: "操作",
          width: 180,
          fixed: "right",
          align: "center",
          render: (h, params) => {
            const { id, evidenceUrl, auditStatusStr } = params.row;

            let operation = [];
            if (
              this.$hasPermission(this.$route, "audit") &&
              auditStatusStr == "待审核"
            ) {
              operation.push(
                <el-button
                  v-on:click={this.showAuditView.bind(this, params.row)}
                  type="text"
                >
                  审核
                </el-button>
              );
            }
            if (
              this.$hasPermission(this.$route, "edit") &&
              (auditStatusStr == "审核驳回" ||
                auditStatusStr == "草稿" ||
                auditStatusStr == "待审核")
            ) {
              operation.push(
                <el-button
                  v-on:click={this.showAddTaxM.bind(this, params.row)}
                  type="text"
                >
                  编缉
                </el-button>
              );
            }
            if (this.$hasPermission(this.$route, "voucher")) {
              operation.push(
                <el-button
                  v-on:click={this.showVoucher.bind(this, evidenceUrl)}
                  type="text"
                >
                  凭证
                </el-button>
              );
            }
            if (this.$hasPermission(this.$route, "operateLog")) {
              operation.push(
                <el-button
                  v-on:click={this.showListOperateLog.bind(this, id)}
                  type="text"
                >
                  日志
                </el-button>
              );
            }
            return <div>{operation}</div>;
          },
        },
      ],
      filterObj: {
        orderId: "",
      },
      currentRow: [],
      sortObj: {},
      wordStrToRechargeType: {
        罚款缴纳: "TAX_PENALTY",
        税金充值: "TAX_PREPAY",
        税金补缴: "BACK_TAX",
      },
    };
  },
  computed: {
    ...mapGetters(["getEECommerce", "portList"]),
  },
  methods: {
    saveTax(status) {
      if (!this.addTaxForm.evidenceUrl) {
        this.$message.warning("请上传凭证或静等凭证上传成功");
        return;
      }
      if (!this.addTaxForm.uploadSuccess) {
        this.$message.warning("请等待凭证上传成功");
        return;
      }
      const userInfo = getUserInfo();
      if (this.addTaxForm.rechargeAmount == null) {
        this.$message.warning("金额必填");
        return;
      }
      const rechargeAmount = parseFloat(this.addTaxForm.rechargeAmount) * 100;
      let param = {
        request: JSON.stringify({
          ...this.addTaxForm,
          rechargeAmount,
          ...{
            accountType: "PROVIDER",
            taxRechargeAuditStatusStr: status,
            rechargeSourceStr: "PROVIDER",
            oprator: userInfo.nick,
          },
        }),
      };
      let requestApi =
        this.addTaxForm.id == null ? this.add(param) : this.edit(param);

      requestApi.then((res) => {
        this.addTaxForm = JSON.parse(this.defaultAddTaxForm);
        if (res.value === true) {
          this.$message.success("成功");
        } else {
          this.$message.error("失败");
        }
        this.showAddTax = !this.showAddTax;
        this.fetch();
      });
    },
    handlePreview(file) {
      console.log(file);
    },
    fileBeforeUpload(file) {
      this.addTaxForm.uploadSuccess = false;
    },
    fileChange(file, fileList) {
      console.log(file);
    },
    fileProgress(event, file, fileList) {
      console.log(event);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    fileUploadSuccessHandle(res, file) {
      let filUrl = res.content[0][this.uploadName];
      console.log(filUrl);
      this.addTaxForm.evidenceUrl = filUrl;
      this.addTaxForm.uploadSuccess = true;
    },
    ...mapActions({
      query: "tro/pageQuery",
      add: "tro/add",
      edit: "tro/edit",
      audit: "tro/audit",
      listOperateLog: "tro/listOperateLog",
      submitBuildExcelTask: "tro/submitTaxRechargeBuildExcelTask",
    }),
    // 更新品牌列表
    fetch(data) {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = data ? data : this.sortObj;
      this.query({
        ...sortObj,
        request: {
          ...filterParams,
          rechargeSourceStr: "PROVIDER",
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      }).then((res) => {
        this.loading = false;
        this.dataList = res.taxRechargeOrderEntities || [];
        const pageInfo = res.pageInfo || { totalCount: 0 };
        this.pagination = { ...this.pagination, ...pageInfo };
      });
    },
    selectionChange(row) {
      this.currentRow = row;
    },
    showVoucher(url) {
      if (!!url && !url.startsWith("http")) {
        url = CONST_VD_IMGPREFIX.prefixImgUrl + url;
      }
      this.isShowVoucher = !this.isShowVoucher;
      this.voucherUrl = url;
    },
    showAddTaxM(row) {
      this.defaultAddTaxForm = JSON.stringify(this.addTaxForm);
      this.showAddTax = !this.showAddTax;
      if (row != null) {
        //this.addTaxForm.id=row.id;
        for (let key in this.addTaxForm) {
          this.addTaxForm[key] = row[key];
        }
        this.addTaxForm.rechargeAmount = (
          parseInt(this.addTaxForm.rechargeAmount) / 100
        ).toFixed(2);
        this.addTaxForm.rechargeTypeStr = this.wordStrToRechargeType[
          row.rechargeTypeStr
        ];
        this.addTaxForm.uploadSuccess = true;
        this.addTaxForm.fileList = [
          { name: "凭证", url: this.addTaxForm.evidenceUrl },
        ];
      }
    },
    showAuditView(row) {
      this.isShowAudit = !this.isShowAudit;
      this.currentAudit = row;
    },
    exportList(data) {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = data ? data : this.sortObj;
      this.submitBuildExcelTask({
        ...sortObj,
        request: {
          ...filterParams,
          rechargeSourceStr: "ENTERPRISE",
          pageIndex: 1,
          pageSize: 9999,
        },
      }).then((res) => {
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
    auditTax(id, status) {
      const userInfo = getUserInfo();
      this.audit({
        request: JSON.stringify({
          id: id,
          auditStatus: status,
          oprator: userInfo.nick,
          remarks: this.auditDataForm.remarks,
        }),
      }).then((res) => {
        this.isShowAudit = !this.isShowAudit;
        this.auditDataForm.remarks = "";
        if (res.value === true) {
          this.$message.success("成功");
        } else {
          this.$message.error("失败");
        }
        this.fetch();
      });
    },
    showListOperateLog(id) {
      let __this = this;
      __this.taxOpratorLogData = [];
      this.isShowListOprator = !this.isShowListOprator;
      this.listOperateLog({
        request: JSON.stringify({
          rechargeOrderId: id,
        }),
      })
        .then((res) => {
          __this.taxOpratorLogData = res.taxRechargeOrderLogEntityList;
        })
        .catch((error) => {
          this.$message.error(error || "服务器异常");
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "口岸",
              model: "portNid",
              type: type.SELECT,
              props: {
                data: this.portList,
              },
            },
            {
              label: "电商企业",
              model: "enterpriseNid",
              type: type.SELECT,
              props: {
                data: this.getEECommerce,
              },
            },
            {
              label: "充值类型",
              model: "rechargeTypeStr",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "TAX_PENALTY",
                    label: "罚款缴纳",
                  },
                  {
                    value: "TAX_PREPAY",
                    label: "税金充值",
                  },
                  {
                    value: "BACK_TAX",
                    label: "税金补缴",
                  },
                ],
              },
            },
            {
              label: "审核状态",
              model: "auditStatusStr",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  {
                    value: "DRAUGHT",
                    label: "草稿",
                  },
                  {
                    value: "WAIT_AUDIT",
                    label: "待审核",
                  },
                  {
                    value: "AUDIT_PASS",
                    label: "审核通过",
                  },
                  {
                    value: "AUDIT_REJECT",
                    label: "审核驳回",
                  },
                ],
              },
            },
          ],
        },
      ];
    },
  },
};
</script>
